import { useEffect } from 'react';
import { EventType } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useAppDispatch, useAppSelector } from 'core/store';
import { loadProfileAction } from 'core/store/auth';
import { authGetCustomerSelector, authLoadingSelector } from 'core/store/auth/selectors';
import { loadCreditLimitsAction } from 'core/store/credits';
import gtmEvents from 'shared/utils/gtm-events';

const useInitializeUser = () => {
  const dispatch = useAppDispatch();
  const isLogged = useIsAuthenticated();
  const loading = useAppSelector(authLoadingSelector);
  const { instance } = useMsal();

  const customer = useAppSelector(authGetCustomerSelector);

  useEffect(() => {
    if (isLogged) {
      dispatch(loadProfileAction());
      dispatch(loadCreditLimitsAction());
    }
  }, [isLogged, dispatch]);

  useEffect(() => {
    const callbackId = instance.addEventCallback(message => {
      if (message.eventType === EventType.LOGIN_SUCCESS) {
        if (customer) {
          gtmEvents.triggerLoginSuccessEvent({
            document: customer.basicData.document.number,
            priceList: customer.priceList,
            externalDistributorName: customer.externalDistributorName,
            docType: customer.basicData.document.type,
          });
        }
        if (message.payload) {
          const { payload } = message;
          if ('account' in payload && payload.account) instance.setActiveAccount(payload.account);
        }
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [customer, instance]);

  return {
    loading,
  };
};

export default useInitializeUser;
